import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { consumerTheme } from 'syf-component-library/defaultTheme';
import { I18nextProvider } from 'react-i18next';
import { CoreConfigProvider } from '@account-services-mfe/core';
import i18n from '../strings/i18n';
const DefaultProviders = ({ config, children }) => {
    return (_jsx(CoreConfigProvider, { value: config, children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(ThemeProvider, { theme: consumerTheme, children: children }) }) }));
};
export default DefaultProviders;
